import sanitizeHtml from "sanitize-html";

sanitizeHtml.defaults.allowedAttributes["div"] = ["class", "style"];
sanitizeHtml.defaults.allowedAttributes["span"] = ["class", "style"];
sanitizeHtml.defaults.allowedAttributes["p"] = ["class", "style"];
sanitizeHtml.defaults.allowedAttributes["h1"] = ["class", "style"];
sanitizeHtml.defaults.allowedAttributes["h2"] = ["class", "style"];
sanitizeHtml.defaults.allowedAttributes["h3"] = ["class", "style"];
sanitizeHtml.defaults.allowedAttributes["h4"] = ["class", "style"];
sanitizeHtml.defaults.allowedAttributes["h5"] = ["class", "style"];
sanitizeHtml.defaults.allowedAttributes["h6"] = ["class", "style"];
sanitizeHtml.defaults.allowedAttributes["ul"] = ["class", "style"];
sanitizeHtml.defaults.allowedAttributes["li"] = ["class", "style"];
sanitizeHtml.defaults.allowedAttributes["a"] = [
	"class",
	"style",
	"href",
	"target",
];
sanitizeHtml.defaults.allowedTags.push("img");
sanitizeHtml.defaults.allowedAttributes["img"] = [
	"class",
	"style",
	"src",
	"alt",
];

export default sanitizeHtml.defaults;
